export const APP_NAME = import.meta.env.VITE_APP_NAME || 'PracticeNova';

export const ROUTES = {
  LOGIN: '/login',
  VERIFY: '/verify',
  ONBOARDING: '/onboarding',
  DASHBOARD: '/',
  SEO: '/seo',
  ADS: '/campaigns',
  ADS_RECOMMENDATIONS: '/campaigns/recommendations',
  STRATEGY: '/strategy',
  STRATEGY_EDIT: '/strategy/edit',
  SETTINGS: '/settings',
  SETTINGS_PRACTICE: '/settings/practice',
  SETTINGS_LOCATIONS: '/settings/locations',
  SETTINGS_TEAM: '/settings/team',
  SETTINGS_PAID: '/settings/paid',
  SETTINGS_ORGANIC: '/settings/organic',
  AGENCY: '/agency',
  AGENCY_PRACTICE: (id: string) => `/agency/practices/${id}`,
};

export const PRIORITY_COLORS = {
  HIGH: '#F44336',
  MEDIUM: '#FF9800',
  LOW: '#4CAF50',
};
